import { render } from "./CampaignsDetails.vue?vue&type=template&id=49280ffc"
import script from "./CampaignsDetails.vue?vue&type=script&lang=js"
export * from "./CampaignsDetails.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__